<template>
    <div v-loading.fullscreen.lock="fullscreenLoading">

        <!--コンテンツ-->
        <main id="renew2_mypage">
            <div class="yagioffer_container">
                <div class="renew2_wrapper renew2_flex">
                    <div class="servicelist">
                        <ul class="servicelist__block renew2_pc">
                            <li class="servicelist__item waiting"><a href="/kr/resume/mypage"><img
                                        src="/kr/resume/static/renew2_img/icon_mypagetop.svg" alt="마이페이지"><br>마이페이지</a>
                            </li>
                            <li class="servicelist__item onclick"><a href="/kr/resume/mypage/yagioffer"><img
                                        src="/kr/resume/static/renew2_img/icon_yagioffer.svg" alt="야기오퍼"><br>야기오퍼</a>
                            </li>
                            <li class="servicelist__item waiting"><a href="/kr/resume/mypage/quickmail"><img
                                        src="/kr/resume/static/renew2_img/icon_quickmail.svg" alt="야기택배"><br>야기택배</a>
                            </li>
                            <li class="servicelist__item waiting"><a href="/kr/resume/mypage/quickemail"><img
                                        src="/kr/resume/static/renew2_img/icon_quickemail.svg" alt="야기메일"><br>야기메일</a>
                            </li>
                            <li class="servicelist__item waiting"><a href="/kr/resume/mypage/introduction"><img
                                        src="/kr/resume/static/renew2_img/icon_recommend.svg"
                                        alt="추천·소개서"><br>추천·소개서</a></li>
                        </ul>
                        <div class="renew2_sp">
                            <ul class="servicelist__block renew2_sp_flex">
                                <li class="servicelist__item onclick"><a href="/kr/resume/mypage/yagioffer"><img
                                            src="/kr/resume/static/renew2_img/icon_yagioffer.svg"
                                            alt="야기오퍼"><br>야기오퍼</a></li>
                                <li class="servicelist__item waiting"><a href="/kr/resume/mypage/quickmail"><img
                                            src="/kr/resume/static/renew2_img/icon_quickmail.svg"
                                            alt="야기택배"><br>야기택배</a></li>
                                <li class="servicelist__item waiting"><a href="/kr/resume/mypage/quickemail"><img
                                            src="/kr/resume/static/renew2_img/icon_quickemail.svg"
                                            alt="야기메일"><br>야기메일</a></li>
                                <li class="servicelist__item waiting"><a href="/kr/resume/mypage/introduction"><img
                                            src="/kr/resume/static/renew2_img/icon_recommend.svg"
                                            alt="추천·소개서"><br>추천·소개서</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="mypage_contents">
                        <div class="renew2_flex lead">
                            <h2>야기오퍼</h2>
                            <a href="/kr/resume/yagiofferhelp" target="_blank" class="">야기오퍼란?</a>
                        </div>
                        <p>신규채용을 하고있는 회사로부터 입사오퍼를 받을수 있습니다.</p>
                        <p class="memo">※이름,주소등의 개인정보는 지원자가 오퍼를 승낙 할때까지 구인회사는 열람 할 수 없습니다.<br>
                        </p>
                        <div class="yagioffer_block">
                            <p class="not_used">이용내역이 없습니다.</p>
                            <ul class="yagioffer_block__list">

                                <li class="renew2_flex yagioffer_block__item"
                                    v-for="(item, index) in yagiOfferData.offer_list" :key="index">
                                    <div class="status renew2_flex renew2_sp_flex">
                                        <p class="date">{{ item.offer_date }}</p><!--日付-->

                                        <p v-if="item.offer_status == 'accept'" class="offer_status status_approved">수락
                                        </p>
                                        <p v-else-if="item.offer_status == 'refuse'"
                                            class="offer_status status_decline">
                                            거절</p>
                                        <p v-else class="offer_status status_undecided">미정</p>

                                    </div>
                                    <p class="company">{{ item.company_name }}</p>

                                    <div v-if="!item.detail_display" class="confirmation_btn"
                                        @click="!item.detail_display ? item.detail_display = true : item.detail_display = false">
                                        <label for="confirmation1" class="confirmation">확인</label>
                                    </div>
                                    <div v-else class="confirmation_btn"
                                        @click="!item.detail_display ? item.detail_display = true : item.detail_display = false">
                                        <label for="confirmation1" class="confirmation"><i
                                                class="el-icon-circle-close-outline"></i>닫기</label>
                                    </div>


                                    <div class="dropdown1" v-if="item.detail_display">
                                        <div class="renew2_flex dropdown_box">
                                            <p class="dropdown_company">기업명：<span>{{ item.company_name }}</span></p>
                                            <div class="dropdown_link">
                                                <a v-if="item.company_url" :href="item.company_url" target="_blank"
                                                    class="dropdown_link__site">기업HP</a>
                                                <a v-if="item.offer_attach_link1" :href="item.offer_attach_link1"
                                                    target="_blank">첨부자료</a>
                                            </div>
                                        </div>
                                        <img v-if="item.company_logo" :src="item.company_logo" alt="회사로고"
                                            class="dropdown_link__logo">
                                        <p class="dropdown_message">
                                        <pre
                                            style="font-family: M PLUS Rounded\ 1c,sans-serif;white-space: pre-wrap;overflow-y: scroll;">{{ item.offer_message }}</pre>
                                        </p>

                                        <div class="reply_btn" v-if="item.offer_status == 'send'">
                                            <el-button id="submit_offer" type="success" class="offer_approved"
                                                @click="submitOffer(item.offer_id)">오퍼수락</el-button>
                                            <br>
                                            <el-button id="deny_offer" type="success" class="offer_decline"
                                                @click="denyOffer(item.offer_id)">거절</el-button>
                                        </div>
                                    </div>
                                </li>



                            </ul>
                        </div>
                        <div class="renew2_sp">
                            <a href="/kr/resume/mypage" class="servicelist__mypage"><img
                                    src="/kr/resume/static/renew2_img/icon_mypagetop.svg" alt="마이페이지">마이페이지로</a>
                        </div>
                    </div>
                </div>
            </div>
        </main>

    </div>
</template>

<style lang="css" src="@/assets/css/renew2_mypage.css"></style>


<style scoped></style>



<script>
import {
    TabPane,
    Tabs,
    MessageBox
} from 'element-ui'
import LoginForms from '@/components/RenewLoginForms'
import firebase from 'firebase/app'

export default {
    components: {
        'login-forms': LoginForms
    },
    data: function () {
        return {
            fullscreenLoading: true,
            recentEdit: {
                FormatId: ''
            },
            dialogVisible: false,
            selectedYagiOfferData: {},
            yagiOfferData: [],
            previewLoading: false
        }
    },
    computed: {
        getMode: function () {
            return process.env.VUE_APP_MODE
        }
    },
    methods: {
        openYagiOfferDetailDialog: function (offer_id, read_flag) {
            const app = this
            if (read_flag != '1') {
                const app = this
                const formData = new FormData()
                formData.append('offer_id', offer_id)
                formData.append('uuid', app.$firebase.user.uid)

                this.$axios
                    .post(this.$varuna.endPoints.readYagiOffer, formData, { timeout: 60000 })
                    .then(function (response) {
                        for (let _item of app.yagiOfferData.offer_list) {
                            if (_item.offer_id == offer_id) {
                                _item.read_flag = '1'
                            }
                        }
                    })
                    .catch(function (error) { })
                    .finally(function () { })
            }
        },
        submitOffer: function (offer_id) {
            const app = this
            const formData = new FormData()
            formData.append('offer_id', offer_id)
            formData.append('uuid', app.$firebase.user.uid)

            this.$axios
                .post(this.$varuna.endPoints.submitYagiOffer, formData, { timeout: 60000 })
                .then(function (response) {
                    for (let _item of app.yagiOfferData.offer_list) {
                        if (_item.offer_id == offer_id) {
                            _item.offer_status = 'accept'
                        }
                    }
                    app.$message({
                        duration: 3000,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `오퍼를 수락하였습니다.`,
                        type: 'success'
                    })
                })
                .catch(function (error) {
                    app.$message({
                        duration: 3000,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `오퍼수락 처리를 실패하였습니다.`,
                        type: 'error'
                    })
                }).finally(function () {

                })
            console.error(this.selectedYagiOfferData.offer_id)
        },
        denyOffer: function (offer_id) {
            const app = this
            const formData = new FormData()
            formData.append('offer_id', offer_id)
            formData.append('uuid', app.$firebase.user.uid)

            this.$axios
                .post(this.$varuna.endPoints.denyYagiOffer, formData, { timeout: 60000 })
                .then(function (response) {
                    for (let _item of app.yagiOfferData.offer_list) {
                        if (_item.offer_id == offer_id) {
                            _item.offer_status = 'refuse'
                        }
                    }
                    app.$message({
                        duration: 3000,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `오퍼를 거절하였습니다.`,
                        type: 'success'
                    })
                })
                .catch(function (error) {
                    app.$message({
                        duration: 3000,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `오퍼 거절처리를 실패하였습니다.`,
                        type: 'error'
                    })
                }).finally(function () {

                })
            console.error(this.selectedYagiOfferData.offer_id)
        }
    },
    created: function () {
        const app = this
        // console.log(this.$route.query.mynavi)
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                console.log('logined')
                const formData = new FormData()
                formData.append('access_id', '')
                formData.append('uuid', app.$firebase.user.uid)
                formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
                formData.append('version', '2')
                formData.append('reqflg', '2')
                this.$axios
                    .post(this.$varuna.endPoints.getYagiOfferList, formData, { timeout: 60000 })
                    .then(function (response) {
                        app.yagiOfferData = response.data
                        console.error(app.yagiOfferData)
                    })
                this.fullscreenLoading = false

            } else {
                this.$router.push('/login')
            }
        })
    },
    beforeMount: function () {
    },
    destroyed: function () {
    }
}
</script>
